var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataChanged)?_c('div',{staticClass:"float-right",attrs:{"title":_vm.message}},[_c('FontAwesomeIcon',{style:({ color: '#FF8200' }),attrs:{"size":"lg","icon":"exclamation-circle"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }